import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Box, Grid, IconButton } from "@mui/material";
import { SaveRounded } from "@mui/icons-material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import DataTable from "../../components/common/DataTable";
import CustomTextField from "../common/CustomTextField";
import CustomButton from "../common/CustomButton";
import { getLeadStages } from "../../services/CommonServices";

const title = "Lead Stages";

const LeadStages = () => {
    const navigate = useNavigate();
    const [leadStages, setLeadStages] = useState([]);

    const [formData, setFormData] = useState({
        shortName: "",
        leadStage: "",
    });

    const columns = useMemo(
        () => [
            { accessorKey: 'id', header: 'SN', size: 50 },
            { accessorKey: 'shortName', header: 'Short Name', size: 150 },
            { accessorKey: 'title', header: 'Lead Stage', size: 200 },
            {
                accessorKey: "action",
                header: "Action",
                size: 50,
                Cell: ({ row }) => (
                    <IconButton onClick={() => handleViewClick(row.original.sn)}>
                        <VisibilityIcon />
                    </IconButton>
                ),
            },
        ],
        []
    );

    const handleViewClick = (id) => {
        navigate(`/app/lead-stage/${id}`);
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const getLeadStagesData = async () => {
        const leadStagesData = await getLeadStages();
        setLeadStages(leadStagesData);
    };

    useEffect(() => {
        getLeadStagesData();
    }, []);

    return (
        <>
            <Box sx={{ paddingLeft: "10px" }} >
                <form>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                            <CustomTextField
                                type="text"
                                name="shortName"
                                fieldLabel="Short Name:"
                                value={formData.shortName}
                                required={true}
                                onChange={handleChange}
                                placeholder="Enter Short Name"
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                            <CustomTextField
                                type="text"
                                name="leadStage"
                                fieldLabel="Lead Stage:"
                                value={formData.leadStage}
                                required={true}
                                onChange={handleChange}
                                placeholder="Enter Lead Stage"
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                            <br />
                            <CustomButton
                                startIcon={<SaveRounded />}
                                title="Save"
                                size="small"
                                variant="contained"
                            />
                        </Grid>
                    </Grid>
                </form>
            </Box>
            <Box sx={{ padding: "10px" }}>
                <DataTable
                    title={title}
                    columns={columns}
                    data={leadStages}
                />
            </Box>
        </>
    );
};

export default LeadStages;
